import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, watch } from "vue";
  import { useStore } from "vuex";
  import { BuilderInterfaceWithHouseDesigns } from "@/types/BuilderInterface";
  import router from "@/router";
  import { HouseDesignInterface } from "@/types/HouseDesignInterface";
  import ConfirmDeleteModalVue from "@/components/ui/modals/ConfirmDeleteModal.vue";
  import { useToast } from "vue-toastification";
  import InputSearch from "@/components/ui/input/InputSearch.vue";
  import { formatPrice as formatPriceOrSize } from "@/helpers/transformation/price";
  import { debounce } from "@/helpers/debounce";
  import { isValidFileSize, isXlsxType } from "@/helpers/fileUpload";
  import AssetGallery, {
    assetInterface,
  } from "@/components/builder/gallery/AssetGallery.vue";
  import { FacadeInterface } from "@/types/FacadeInterface";
  import { AssetGalleryFormType } from "@/enums/AssetGalleryFormType";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminBuilderDetails',
  setup(__props, { expose: __expose }) {
  __expose();

  const builder = ref<BuilderInterfaceWithHouseDesigns>();
  const houses = ref<HouseDesignInterface[]>([]);

  const loading = ref(false);
  const isConfirmDeleteBuilderModalOpen = ref(false);
  const searchQuery = ref("");

  const store = useStore();
  const toast = useToast();

  const builderId = router.currentRoute.value.params.builderId;

  onMounted(() => {
    getBuilderWithHouses();
  });

  watch(
    () => searchQuery.value,
    () => {
      debounceSearch();
    }
  );

  const onUpdateBuilder = () => {
    router.push({ name: "AdminBuilderUpdate", params: { builderId } });
  };
  const onUpdateHouse = (houseId: string) => {
    router.push({ name: "AdminBuilderUpdateHouse", params: { houseId } });
  };

  const onCreateHouse = () => {
    router.push({ name: "AdminBuilderCreateHouse" });
  };

  const getPrice = ({ basePrice }: HouseDesignInterface) =>
    !basePrice ? "-" : `${formatPriceOrSize(basePrice)}`;

  const getBuilderWithHouses = async () => {
    try {
      const { data } = await store.dispatch(
        "builder/getBuilderWithHouses",
        builderId
      );
      const builderData: BuilderInterfaceWithHouseDesigns = data[0];

      builder.value = builderData;
      houses.value = builderData.houses;
    } catch (error) {
      toast.error("Error getting builder");
    }
  };
  const deleteBuilder = async () => {
    loading.value = true;

    try {
      await store.dispatch("builder/deleteBuilder", builderId);
      toast.success("Builder deleted");
      router.push({ name: "AdminBuilders" });
    } catch (error) {
      toast.error("Deleting builder failed");
    } finally {
      loading.value = false;
    }
  };

  const getHouses = async () => {
    try {
      const { data } = await store.dispatch("builder/getHousesByBuilderId", {
        name: searchQuery.value,
        builderId,
      });

      houses.value = data;
    } catch (error) {
      toast.error("Error getting houses");
    }
  };

  const debounceSearch = debounce(getHouses);

  const isConfirmDeleteHouseModalOpen = ref(false);
  const isAddFacadeInGalleryModalOpen = ref(false);
  const isUpdateFacadeInGalleryModalOpen = ref(false);
  const facadeToUpdate = ref<FacadeInterface | null>(null);
  const assetToUpdate = ref<assetInterface | null>(null);

  const reloadAssetGallery = ref(false);
  const houseToDelete = ref<HouseDesignInterface | null>(null);

  const isAssetGalleryModalOpen = ref(false);

  const updateAsset = (asset: assetInterface) => {
    assetToUpdate.value = asset;
    isAssetGalleryModalOpen.value = true;
  };

  const onDeleteHouse = (house: HouseDesignInterface) => {
    isConfirmDeleteHouseModalOpen.value = true;
    houseToDelete.value = house;
  };

  const deleteHouse = async () => {
    if (!houseToDelete.value) {
      return;
    }

    loading.value = true;

    try {
      await store.dispatch("builder/deleteHouse", houseToDelete.value._id);
      toast.success("House design deleted");
      isConfirmDeleteHouseModalOpen.value = false;
      getHouses();
    } catch (error) {
      toast.error("Deleting house design failed");
    } finally {
      loading.value = false;
    }
  };
  const bulkUpload = async (e: Event) => {
    const input = e.target as HTMLInputElement;

    if (!input.files || !input.files.length) {
      return;
    }

    const selectedFile = input.files[0];

    if (!isXlsxType(selectedFile) || !isValidFileSize(selectedFile)) {
      return;
    }

    const data = new FormData();

    data.append("file", selectedFile);

    try {
      await store.dispatch("builder/bulkHouseUpload", { builderId, data });
      toast.success("House design uploaded");
      getHouses();
    } catch (error) {
      toast.error("Invalid file data");
    } finally {
      loading.value = false;
    }
  };

const __returned__ = { builder, houses, loading, isConfirmDeleteBuilderModalOpen, searchQuery, store, toast, builderId, onUpdateBuilder, onUpdateHouse, onCreateHouse, getPrice, getBuilderWithHouses, deleteBuilder, getHouses, debounceSearch, isConfirmDeleteHouseModalOpen, isAddFacadeInGalleryModalOpen, isUpdateFacadeInGalleryModalOpen, facadeToUpdate, assetToUpdate, reloadAssetGallery, houseToDelete, isAssetGalleryModalOpen, updateAsset, onDeleteHouse, deleteHouse, bulkUpload, ref, onMounted, watch, get useStore() { return useStore }, get BuilderInterfaceWithHouseDesigns() { return BuilderInterfaceWithHouseDesigns }, get router() { return router }, get HouseDesignInterface() { return HouseDesignInterface }, ConfirmDeleteModalVue, get useToast() { return useToast }, InputSearch, get formatPriceOrSize() { return formatPriceOrSize }, get debounce() { return debounce }, get isValidFileSize() { return isValidFileSize }, get isXlsxType() { return isXlsxType }, AssetGallery, assetInterface, get FacadeInterface() { return FacadeInterface }, get AssetGalleryFormType() { return AssetGalleryFormType } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})